export const LOCALE = 'en-US'
export const CURRENCY = 'EUR'
